import { useQuery } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const useUsers = (params, options, key = "getUsersForManagement") => {
  const axiosPrivate = useAxiosPrivate();
  const getUsersForManagementList = async () => {
    const usersList = await axiosPrivate({
      method: "GET",
      url: "Users/Management/GetUsers",
      params,
    }).then((response) => response.data);
    return usersList;
  };

  return useQuery([key, params], () => getUsersForManagementList(params), {
    ...options,
  });
};

export default useUsers;
